<template>
  <v-container>
    <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
      <v-card class="custom-card" rounded="0">
        <v-toolbar color="secondary" class="white--text">
          <v-toolbar-title class="font-weight-bold">{{
            $t("user.addNewRole")
          }}</v-toolbar-title>

                    <v-spacer></v-spacer>
          <v-btn icon class="white--text" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form
          autocomplete="off"
          @submit.prevent="addRole"
          ref="roleform"
          v-model="valid"
        >
          <v-card-text class="black--text">
            <label class="title" for="name"
              >{{ $t("role") }} <span style="color: red">*</span></label
            >
            <v-text-field
              outlined
              dense
              placeholder="Select Role"
              v-model="rolename"
              :rules="roleRules"
              :error-messages="roleNameError"
            >
            </v-text-field>
            <label class="title" for="name"
              >{{ $t("department") }} <span style="color: red">*</span></label
            >
            <v-select
              :items="departmentList"
              item-text="name"
              item-value="departmentNumber"
              outlined
              placeholder="Select Department"
              dense
              v-model="department"
              :rules="deptRules"
            ></v-select>
            <v-divider></v-divider>
            <v-card-actions class="mt-5 px-0">
              <v-spacer></v-spacer>
              <v-btn
                class="mr-3"
                outlined
                color="primary"
                @click="closeModal"
                width="112"
              >
                {{ $t("cancel") }}
              </v-btn>
              <v-btn
                width="112"
                color="primary"
                type="submit"
                class="btn-11 btn-22"
              >
                {{ $t("submit") }}
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PermissionsService from '@/_services/PermissionsService'
import loading from "@/mixins/LoadingMixin";

export default {
        created() {
            const fetchData = () => {
                PermissionsService.getDepartments({page:1,itemsPerPage:1000, sortBy:['name'], sortDesc: [false]}, '')
                .then( res => {
                    if(res.success){
                        this.departmentList = res.data.departments.rows
                    }
                })
                .catch( error => {
                    console.log('e', error)
                })
            }
            fetchData()
        },
        computed: {
            dialog : {
                get(){
                    return this.dialogI;
                },
                set(){
                    return this.dialogI;
                }
            }
        },
        data() {
            return {
                valid: true,
                roleNameError: '',
                departmentList: [],
                department: '',
                rolename: '',
                roleRules: [
                    v => !!v ||  this.$t("user.roleNameIsRequired"),
                    v => (v && v.length <= 15) || this.$t("user.roleNameMustBeLessThan15Chars"),
                ],
                deptRules: [
                    v => !!v || this.$t("departmentReq"),
                ],
            }
        },
        methods: {
            closeModal() {
                this.$emit('closeAddRole')
            },
            addRole() {
                if(!this.$refs.roleform.validate()) return;
                 this.startLoading()
                PermissionsService.createRole({ name: this.rolename, departmentNumber: this.department })
                .then( respose => {
                    this.stopLoading()
                    if(respose.success){
                        this.$notify({
                            title: this.$t("user.roleAdded"),
                            text: respose.message,
                            type: 'success'
                        });
                        this.$emit('role:added', true)
                    }else{
                        respose.response.data.message.errors.forEach( (err) => {
                            if(err.param == 'name')
                                this.roleNameError = err.msg
                        })
                        // this.$notify({
                        //     title: 'Role not Added',
                        //     text: respose.message,
                        //     type: 'error'
                        // });
                        // this.$emit('role:added', false)
                    }
                })
                .catch(error => {
                    this.stopLoading()
                    console.log('err', error)
                })
            }
        },

        props: ['dialogI'],
        mixins: [loading]
}
</script>
<style lang="scss" scoped>

</style>